
import { StudentWithAttendance } from '@/types/attendance';
import { AlertSettings } from '@/types/alertSettings';

export const filterStudentsByStageGradeSection = (
  students: StudentWithAttendance[],
  selectedStage: string,
  selectedGrade: string,
  selectedSection: string,
  enabledStages: any[]
): StudentWithAttendance[] => {
  // console.log('=== Filter Students Debug ===');
  // console.log('Total students before filtering:', students.length);
  // console.log('Selected stage:', selectedStage);
  // console.log('Selected grade:', selectedGrade);
  // console.log('Selected section:', selectedSection);
  
  let filtered = students;
  
  if (selectedStage && selectedStage !== "all") {
    const stage = enabledStages?.find(s => s.id === selectedStage);
    // console.log('Found stage:', stage);
    
    if (stage && stage.grades) {
      const stageGrades = stage.grades.map(g => g.name);
      // console.log('Stage grades:', stageGrades);
      // console.log('Student grades in data:', [...new Set(students.map(s => s.grade))]);
      
      filtered = filtered.filter(s => {
        const included = stageGrades?.includes(s.grade);
        if (!included) {
          // console.log(`Student ${s.name} excluded - grade ${s.grade} not in stage grades`);
        }
        return included;
      });
    }
  }
  
  // console.log('Students after stage filtering:', filtered.length);
  
  if (selectedGrade && selectedGrade !== "all") {
    filtered = filtered.filter(s => s.grade === selectedGrade);
    // console.log('Students after grade filtering:', filtered.length);
  }
  
  if (selectedSection && selectedSection !== "all") {
    filtered = filtered.filter(s => s.section === selectedSection);
    // console.log('Students after section filtering:', filtered.length);
  }
  
  // console.log('Final filtered students:', filtered.length);
  return filtered;
};

export const getStudentsWithAlerts = (students: StudentWithAttendance[], alertSettings?: AlertSettings | any) => {
  // معالجة البيانات إذا كانت string بدلاً من object
  let processedAlertSettings: AlertSettings | undefined;
  
  if (alertSettings) {
    if (typeof alertSettings === 'string') {
      try {
        processedAlertSettings = JSON.parse(alertSettings);
      } catch (error) {
        console.error('خطأ في تحليل alertSettings:', error);
        processedAlertSettings = undefined;
      }
    } else if (alertSettings?.absence_alerts) {
      processedAlertSettings = alertSettings;
    } else {
      processedAlertSettings = undefined;
    }
  }

  // إذا لم تكن هناك إعدادات تنبيهات غياب، استخدم العتبة الافتراضية
  if (!processedAlertSettings?.absence_alerts) {
    return students.filter(s => s.absenceDays >= 2);
  }

  const enabledAbsenceAlerts =  processedAlertSettings?.absence_alerts
    ?.filter(alert => alert.enabled)
    ?.sort((a, b) => a.threshold - b.threshold);

  if (enabledAbsenceAlerts.length === 0) {
    return students.filter(s => s.absenceDays >= 2);
  }

  // العثور على الحد الأدنى للتنبيه
  const minThreshold = enabledAbsenceAlerts[0].threshold;
  
  return students.filter(s => s.absenceDays >= minThreshold);
};

export const getStudentsWithLateAlerts = (students: StudentWithAttendance[], alertSettings?: AlertSettings | any) => {
  // معالجة البيانات إذا كانت string بدلاً من object
  let processedAlertSettings: AlertSettings | undefined;
  
  if (alertSettings) {
    if (typeof alertSettings === 'string') {
      try {
        processedAlertSettings = JSON.parse(alertSettings);
      } catch (error) {
        console.error('خطأ في تحليل alertSettings:', error);
        processedAlertSettings = undefined;
      }
    } else if (alertSettings.late_alerts) {
      processedAlertSettings = alertSettings;
    } else {
      processedAlertSettings = undefined;
    }
  }

  // إذا لم تكن هناك إعدادات تنبيهات تأخر، استخدم العتبة الافتراضية
  if (!processedAlertSettings?.late_alerts) {
    return students.filter(s => s.lateDays >= 3);
  }

  const enabledLateAlerts = processedAlertSettings?.late_alerts
   ?.filter(alert => alert.enabled)
    ?.sort((a, b) => a.threshold - b.threshold);

  if (enabledLateAlerts.length === 0) {
    return students.filter(s => s.lateDays >= 3);
  }

  // العثور على الحد الأدنى للتنبيه
  const minThreshold = enabledLateAlerts[0].threshold;
  
  return students.filter(s => s.lateDays >= minThreshold);
};

export const getMostAbsentStudents = (students: StudentWithAttendance[], limit: number = 5) => {
  return [...students]
    .sort((a, b) => b.absenceDays - a.absenceDays)
    .slice(0, limit)
    .filter(s => s.absenceDays > 0);
};

export const getMostLateStudents = (students: StudentWithAttendance[], limit: number = 5) => {
  return [...students]
    .sort((a, b) => b.lateDays - a.lateDays)
    .slice(0, limit)
    .filter(s => s.lateDays > 0);
};

export const getBestAttendanceStudents = (students: StudentWithAttendance[], limit: number = 5) => {
  return [...students]
    .sort((a, b) => b.attendancePercentage - a.attendancePercentage)
    .slice(0, limit)
    .filter(s => s.attendancePercentage > 0);
};
